import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from 'material-ui/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Search from 'calcite-react/Search';
import IncidentEditDetails from './IncidentEditDetails';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SyncIcon from '@mui/icons-material/Sync';

class AdminPanel extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      isSearching: false,
      canSearch: false,
      searchIdentifer: null,
      searchValue: '',
      showEditInfo: false,
      editInfoPackage: null,
      isAdmining: false
    };

    this.updateSearchValue = this.updateSearchValue.bind(this);
    this.onUserAction = this.onUserAction.bind(this)
  }

  onClose = () => {
    
    this.setState({
      isSearching: false,
      canSearch: false,
      searchIdentifer: null,
      searchValue: '',
      showEditInfo: false,
      editInfoPackage: null, 
      isAdmining: false
    });

    this.props.onClose();
  }

  onUserAction(value) 
  {
    const searchEnabled = this.state.searchIdentifer !== null && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  updateSearchValue = (value) => {
    const searchEnabled = (this.state.searchIdentifer !== null && this.state.searchIdentifer !== '') && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
}

  searchIncident = () => {
    window.api.searchAdminIncident(this.state.searchValue, this.state.searchIdentifer).then((response) => 
    {
      this.setState({
        showEditInfo: true,
        editInfoPackage: response
      });
    });
  }

  //  //resyncIncident
  resyncIncident = () => {
    this.setState({
      isAdmining: true
    });
    window.api.resyncIncident(this.state.editInfoPackage.FireOccurenceRecord.FireOccurenceRecordID).then((response) => 
    {
      this.setState({
        isAdmining: false
      });
    });
  }
  setIncidentValid = () => {
    const ufi = this.state.editInfoPackage.FireOccurenceRecord.UniqueFireIdentifier;

    this.setState({
      isAdmining: true
    });

    window.api.setIncidentValid(this.state.editInfoPackage.FireOccurenceRecord.FireOccurenceRecordID).then((response) => {
      window.api.searchAdminIncident(ufi, 'UniqueFireIdentifier').then((response) => {
        this.setState({
          showEditInfo: true,
          editInfoPackage: response,
          isAdmining: false
        });
      });
    });
  }

  updateIdentifier = (value) => {

    const searchEnabled = (this.state.searchValue !== null && this.state.searchValue !== '') && value !== null;
    this.setState({
      searchIdentifer: value,
      canSearch: searchEnabled
    });
  }

  render() {

    //const errorString = (this.state.editInfoPackage && this.state.editInfoPackage.Error !== "") ? "<B>Error:</B>" + this.state.editInfoPackage.Error : "";
    //
    const revalidationButton = (this.state.editInfoPackage && this.state.editInfoPackage.FireOccurenceRecord && this.state.editInfoPackage.FireOccurenceRecord.IsValid === 0) ?
    (<Button
      primary={true}
      variant="contained"
      disabled={this.state.isAdmining}
      onClick={this.setIncidentValid} startIcon={<TaskAltIcon />}>Mark Incident as Valid</Button>) : "";

    const resyncButton = (this.state.editInfoPackage && this.state.editInfoPackage.FireOccurenceRecord) ?
    (<Button
      primary={true}
      variant="contained"
      disabled={this.state.isAdmining}
      onClick={this.resyncIncident} startIcon={<SyncIcon />}>Resync Spatial Feature</Button>) : "";

    const spinner = (this.state.isAdmining) ? (<CircularProgress size={24} thickness={2} />) : "";
    const actions = [
      <Button
        variant="text"
        primary={true}
        onClick={this.onClose}>Close</Button>
    ];

    return (
      
      <Dialog
        open={this.props.open}
        modal={true}
        fullScreen
        actions={actions}
        autoScrollBodyContent={true}
        contentStyle={{ width: '80%', height: '70%', maxWidth: 'none', overflowy: 'auto' }}>
        <Paper>
          <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                Admin
              </Typography>
             
              <IconButton color="inherit" onClick={this.onClose} style={{ position: "relative", float: "right", }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
            
          </AppBar>
           <div>
           <Stack spacing={2} direction="row">
           <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Search by:</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(event) => {
                    this.updateIdentifier(event.target.value);
                  }}>
                  <FormControlLabel value="UniqueFireIdentifier" control={<Radio />} label="Unique Fire Identifier" />
                  <FormControlLabel value="FORID" control={<Radio />} label="FORID" />
                  <FormControlLabel value="IRWINID" control={<Radio />} label="IRWIN ID" />
                </RadioGroup>
              </FormControl>
              <div style={{marginTop: "58px", width: "400px"}}>
                <Search fullWidth label="Identifier" onChange={this.updateSearchValue} inputValue={this.state.searchValue} onUserAction={this.onUserAction}/>
              </div>
              <Button variant="contained" disabled={!this.state.canSearch} style={{height:'30px', marginTop: "67px"}} onClick={this.searchIncident}>Search</Button>
             
          </Stack>
          <Stack spacing={2} direction="row" style={{marginLeft: "150px"}}>
              {resyncButton}
              {revalidationButton}
              {spinner}
              </Stack>
          <IncidentEditDetails visible={this.state.showEditInfo} editInfoPackage={this.state.editInfoPackage} />
          </div>
        </Paper>
      </Dialog>
    );
  }
}
export default AdminPanel;
